import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  inMemoryPersistence,
  initializeAuth,
} from "firebase/auth";
import { isPublicLinkPage } from "@shared/publicLinks";

// Railway Docker build can miss VITE_* vars at build-time.
// Keep a safe fallback for public Firebase web config to avoid blank screen.
const fallbackFirebaseConfig = {
  apiKey: "AIzaSyBq6fGreH4LwuvQS1XW8gyyZ6PrfKWLw5k",
  authDomain: "www.hrcrm.asia",
  projectId: "recruit-crm-2026",
  storageBucket: "recruit-crm-2026.firebasestorage.app",
  messagingSenderId: "582060157621",
  appId: "1:582060157621:web:4963694ddaf99a7ebeecfc",
};

const firebaseConfig = {
  apiKey:
    import.meta.env.VITE_FIREBASE_API_KEY || fallbackFirebaseConfig.apiKey,
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ||
    fallbackFirebaseConfig.authDomain,
  projectId:
    import.meta.env.VITE_FIREBASE_PROJECT_ID ||
    fallbackFirebaseConfig.projectId,
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||
    fallbackFirebaseConfig.storageBucket,
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ||
    fallbackFirebaseConfig.messagingSenderId,
  appId: import.meta.env.VITE_FIREBASE_APP_ID || fallbackFirebaseConfig.appId,
};

// Диагностика: проверяем что конфиг реально попал в бандл
if (!firebaseConfig.apiKey || firebaseConfig.apiKey === "undefined") {
  console.error(
    "❌ Firebase config empty — VITE_FIREBASE_* не попали в билд.\n" +
      "   → Проверь ARG директивы в Dockerfile\n" +
      "   → Проверь VITE_FIREBASE_* в Railway variables\n" +
      "   → Используется fallback: " +
      (fallbackFirebaseConfig.apiKey ? "да" : "НЕТ")
  );
}

const app = initializeApp(firebaseConfig);
// Внешние страницы (кандидат, заказчик) никого не впускают по Google-входу и
// токен не шлют. Полный getAuth на телефоне и в Safari сразу грузит скрытое
// окно входа с адреса authDomain (www.hrcrm.asia), и каждый запрос к серверу
// ждёт его готовности. На адресе агентства interview.changehr.kz это окно
// чужое и запрещено заголовком X-Frame-Options — кандидат ждал бы секунды до
// первого ответа. Вход «в памяти» без окна готов сразу (29.09.2026).
export const auth = isPublicLinkPage(window.location.pathname)
  ? initializeAuth(app, { persistence: inMemoryPersistence })
  : getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

// Диагностика auth ошибок
auth.onAuthStateChanged(
  () => {},
  error => {
    console.error(
      "❌ Firebase Auth ошибка: " +
        error.message +
        "\n" +
        "   → Проверь authDomain в конфиге: " +
        firebaseConfig.authDomain +
        "\n" +
        "   → Проверь что домен в Firebase Console → Authorized domains\n" +
        "   → Проверь navigateFallbackDenylist в vite.config.ts (SW не должен перехватывать /__/)"
    );
  }
);
